import * as React from "react";
import {observable} from "mobx";
import {CrudForm} from "../crud/CrudForm";
import {Field} from "../form/Field";
import {Select} from "../form/fields/Select";
import {api} from "../../api";
import {IWindow} from "../../index";
import {FormStore} from "../../stores/FormStore";
import {Col, Row} from "reactstrap";
import {Input} from "../form/fields/Input";
// import {BarChart} from "../charts/BarChart";
// import {DoughnutChat} from "../charts/DoughnutChat";
// import {HasPermission} from "../HasPermission";

const IWindow: IWindow = (window as IWindow);

class SearchForm {
    @observable search = '';
}

export class ResultSummaryNewFilterForm {
    @observable name = '';
    @observable election_id = null;
	@observable position_id = null;
    @observable election_position_id = null;
    @observable user_party_id = IWindow.initialState.user.party_id;
    @observable party_id = null;
    @observable candidate_id = null;
    @observable level = null;
    @observable state_id = null; 
    @observable senatorial_district_id = null;
    @observable federal_constituency_id = null;
    @observable local_government_area_id = null;
    @observable state_constituency_id = null;
    @observable ward_id = null;
    @observable page = null;
}

export class ResultSummaryNewFormData {
    @observable election_id = null;
    @observable position_id = null;
    @observable party_id = IWindow.initialState.user.party_id;
	@observable election_position_id = null;
	@observable user_party_id = IWindow.initialState.user.party_id;
}

export class ResultSummaryNewForm extends CrudForm {
    modelName = 'Dashboard';
    showSubmitButton = false;
	@observable is_load_done_election: string = 'n';
    @observable is_load_done: string = 'n';
	@observable searchFormStore: FormStore<SearchForm>;
	@observable filterFormStore: FormStore<any>;
	@observable user_party_id = IWindow.initialState.user.party_id;
	@observable election_position_id = null;
    @observable party_candidates: [];
    @observable candidate_by_position: any = [];
	@observable totalVotes: any = [];
    @observable other_party_candidates: any = [];
	@observable is_admin = IWindow.initialState.user.user_type;
    @observable electionSubscription = {
        registeredVoters : 0,
        accreditedVoters : 0,
        rejectedVoters   : 0,
        disputedVoters   : 0,
        election_polling_unit : 0,
        election_polling_unit_subscriptions : 0,
        election_unsubscribed_polling_unit : 0,
        federal_constituencies: 0,
        local_government_areas: 0,
        senatorial_districts: 0,
        state_constituencies: 0,
        states: 0,
        wards: 0,
        incidence_count: 0,
        election_candidates_votes: [],
        pollingUnitName: [],
        pollingUnitCode: [],
        pollingUnitState: [],
        total_votes: [],
        grandTotal: [],
        election_positions: [],
        check_list_count: [],
       
    };
    @observable check_lists: any = [];

    loadMoreData(props: any, module: any) {
        this.onLoadCheckLists();
    }
	onLoadElectionsData = () => {
        return api.election.getListAction({
            filters: {
                party_id: IWindow.initialState.user.party_id,
            }
        }).then((data: any) => {
            if (data && data.length) {
                if(this.is_load_done_election == "n")
                    this.filterFormStore.setValue('election_id', data[0].id);
            }
            this.is_load_done_election = "y";
            return data;
        });
    };

    onLoadElectionsParty = () => {
        return api.party.getListAction({
            filters: {
                election_id: this.filterFormStore.getValue('election_id'),
                include_competitor_party: 1
            }
        }).then((data: any) => {
            if (data && data.length) {
                if(this.is_load_done == "n")
                    this.filterFormStore.setValue('party_id', data[0].id);
            }
            this.is_load_done = "y";
            return data;
        });
    };
	
	stateDropDown() {
        return <Col md={2}>
            <Field
                key={'state_id_' + this.filterFormStore.getValue('level') +
                this.filterFormStore.getValue('election_position_id') +
                this.filterFormStore.getValue('election_id')
                }
                name="state_id"
                placeholder="Select State"
                component={Select}
                loadOptions={() => {
                    return api.state.getListAction({
                        filters: {
                            election_id: this.filterFormStore.getValue('election_id'),
                            election_position_id: this.filterFormStore.getValue('election_position_id'),
                            level: this.filterFormStore.getValue('level'),
                            user_party_id: this.filterFormStore.getValue('user_party_id'),
                        }
                    });
                }}
                store={this.filterFormStore}
                onChange={() => {
                    this.filterFormStore.setValue('senatorial_district_id', null);
                    this.filterFormStore.setValue('federal_constituency_id', null);
                    this.filterFormStore.setValue('local_government_area_id', null);
                    this.filterFormStore.setValue('state_constituency_id', null);
                    this.filterFormStore.setValue('ward_id', null);
                }}
            />
        </Col>;
    };
	
	 lgaDropDown() {
        return <Col md={2}>
            <Field
                key={'local_government_area_id_' +
                this.filterFormStore.getValue('election_id') +
                this.filterFormStore.getValue('level') +
                this.filterFormStore.getValue('state_id') +
                this.filterFormStore.getValue('election_position_id') +
                this.filterFormStore.getValue('senatorial_district_id') +
                this.filterFormStore.getValue('federal_constituency_id')
                }
                name="local_government_area_id"
                placeholder="Select LGA"
                component={Select}
                loadOptions={() => {
                    return api.localGovernmentArea.getListAction({
                        filters: {
                            election_id: this.filterFormStore.getValue('election_id'),
                            state_id: this.filterFormStore.getValue('state_id'),
                            senatorial_district_id: this.filterFormStore.getValue('senatorial_district_id'),
                            federal_constituency_id: this.filterFormStore.getValue('federal_constituency_id'),
                            election_position_id: this.filterFormStore.getValue('election_position_id'),
                            level: this.filterFormStore.getValue('level'),
                            user_party_id: this.filterFormStore.getValue('user_party_id'),
                        }
                    });
                }}
                store={this.filterFormStore}
                onChange={() => {
                    this.filterFormStore.setValue('ward_id', null);
                }}
            />
        </Col>;
    };

    wardsDropDown() {
        return <Col md={2}>
            <Field
                key={"ward_id_" +
                this.filterFormStore.getValue('level') +
                this.filterFormStore.getValue('election_id') +
                this.filterFormStore.getValue('state_id') +
                this.filterFormStore.getValue('local_government_area_id') +
                this.filterFormStore.getValue('state_constituency_id') +
                this.filterFormStore.getValue('election_position_id') +
                this.filterFormStore.getValue('user_party_id')
                }
                name="ward_id"
                placeholder="Select Ward"
                component={Select}
                loadOptions={() => {
                    return api.ward.getListAction({
                        filters: {
                            election_id: this.filterFormStore.getValue('election_id'),
                            state_id: this.filterFormStore.getValue('state_id'),
                            local_government_area_id: this.filterFormStore.getValue('local_government_area_id'),
                            state_constituency_id: this.filterFormStore.getValue('state_constituency_id'),
                            election_position_id: this.filterFormStore.getValue('election_position_id'),
                            level: this.filterFormStore.getValue('level'),
                            user_party_id: this.filterFormStore.getValue('user_party_id'),
                        }
                    });
                }}
                store={this.filterFormStore}
            />
        </Col>;
    }

    senatorialDistrictDropDown() {
        return this.filterFormStore.getValue('level') === 'senatorial_district' ?
            <Col md={2}>
                <Field
                    key={'senatorial_district_id_' +
                    this.filterFormStore.getValue('level') +
                    this.filterFormStore.getValue('state_id') +
                    this.filterFormStore.getValue('election_position_id')
                    }
                    name="senatorial_district_id"
                    placeholder="Select Senatorial Districts"
                    component={Select}
                    valueObject={true}
                    loadOptions={() => {
                        return api.senatorialDistrict.getListAction({
                            filters: {
                                state_id: this.filterFormStore.getValue('state_id'),
                                election_position_id: this.filterFormStore.getValue('election_position_id'),
                                level: this.filterFormStore.getValue('level'),
                                party_id: this.filterFormStore.getValue('user_party_id'),
                            }
                        });
                    }}
                    store={this.filterFormStore}
                    onChange={(item: any) => {
                        this.filterFormStore.setValue('ward_id', null);
                        this.filterFormStore.setValue('local_government_area_id', null);

                    }}
                />
            </Col> : '';
    }

    federalConstituencyDropDown() {
        return this.filterFormStore.getValue('level') === 'federal_constituency' ?
            <Col md={2}>
                <Field
                    key={'federal_constituency_id_' +
                    this.filterFormStore.getValue('level') +
                    this.filterFormStore.getValue('state_id') +
                    this.filterFormStore.getValue('election_position_id')
                    }
                    name="federal_constituency_id"
                    placeholder="Select Federal Constituency"
                    component={Select}
                    valueObject={true}
                    loadOptions={() => {
                        return api.federalConstituency.getListAction({
                            filters: {
                                state_id: this.filterFormStore.getValue('state_id'),
                                election_position_id: this.filterFormStore.getValue('election_position_id'),
                                level: this.filterFormStore.getValue('level'),
                                party_id: this.filterFormStore.getValue('user_party_id')
                            }
                        });
                    }}
                    store={this.filterFormStore}
                    onChange={(item: any) => {
                        this.filterFormStore.setValue('ward_id', null);
                        this.filterFormStore.setValue('local_government_area_id', null);
                    }}
                />
            </Col> : '';
    }

    stateConstituencyDropDown() {
        return this.filterFormStore.getValue('level') === 'state_constituency' ?
            <Col md={2}>
                <Field
                    key={'state_constituency_id_' +
                    this.filterFormStore.getValue('level') +
                    this.filterFormStore.getValue('state_id') +
                    this.filterFormStore.getValue('election_position_id')
                    }
                    name="state_constituency_id"
                    placeholder="Select State Constituency"
                    component={Select}
                    valueObject={true}
                    loadOptions={() => {
                        return api.stateConstituency.getListAction({
                            filters: {
                                state_id: this.filterFormStore.getValue('state_id'),
                                election_position_id: this.filterFormStore.getValue('election_position_id'),
                                level: this.filterFormStore.getValue('level'),
                                party_id: this.filterFormStore.getValue('user_party_id')
                            }
                        });
                    }}
                    store={this.filterFormStore}
                    onChange={(item: any) => {
                        this.filterFormStore.setValue('ward_id', null);

                    }}
                />
            </Col> : '';
    }

    onLoadCheckLists = () => {
        api.partyCheckList.getListActionReport({ 
            filters: {
                type: 'polling_unit',
                is_excluded: 0,
                election_id:  this.formStore.getValue('election_id')
            }
        }).then((data: any) => {
            this.check_lists = data;
        });
    };

    onChangeElection = () => { 
        this.formStore.getValue('election_id') &&
          api.dashboard.getElectionPollingUnitSubscriptionAction({
            election_id: this.formStore.getValue('election_id'),
			party_id:  this.formStore.getValue('party_id'),
        }).then((data: any) => {
             this.electionSubscription = data;
			 
			 console.log('election subscription - ' + data);
			 console.log('total votes - ' + this.electionSubscription.total_votes);
			 console.log('polling data - ' + this.electionSubscription.pollingUnitName);
			 
			 
			 
             this.party_candidates = data.election_candidates_votes.filter((candidate: any) => {
                return candidate.party_id == (IWindow.initialState.user.party_id ? IWindow.initialState.user.party_id : this.formStore.getValue('party_id') );
             });
			

            this.other_party_candidates = data.election_candidates_votes.filter((candidate: any) => {
                return candidate.party_id !== (IWindow.initialState.user.party_id ? IWindow.initialState.user.party_id : this.formStore.getValue('party_id') );
            });

            if (data.election_positions && data.election_positions.length) {
                this.formStore.setValue('position_id', data.election_positions[0].value);
                this.candidate_by_position = data.election_candidates_votes.filter((candidate: any) => {
                  
                    return candidate.position_id === data.election_positions[0].value;
                }).map((candidate: any) => {
                    return {
                        label: candidate.name,
                        value: candidate.votes
                    };
                });
            }
        });
    };
	
	renderSearch() {
        return (
            <Field
                placeholder="Search"
                name="search"
                component={Input}
                required={true}
                store={this.searchFormStore}
                addon={{
                    type: 'append',
                    component: <span className="icon-search"/>
                }}
            />
        );
    }
	
	 renderFilters() {
        return (
            <Row className="form-row">
                <Col md={2}>
                    <Field
                         key={'filter-election' + this.filterFormStore.getValue('election_id')}
                        placeholder="Select Election"
                        name="election_id"
                        component={Select} 
                        required={true}
                        loadOptions={this.onLoadElectionsData}
                       /* loadOptions={() => {
                            return api.election.getListAction({
                                filters: {
                                    party_id: IWindow.initialState.user.party_id,
                                }
                            }).then((data: any) => {
                                if (data && data.length) {
                                    this.filterFormStore.setValue('election_id', data[0].id);
                                }
                                return data;
                            });
                        }}*/
                        store={this.filterFormStore}
                    />
                </Col>

                {this.filterFormStore.getValue('election_id') ?
                    <Col md={2}>
                        <Field
                            key={'party_id_' + this.filterFormStore.getValue('election_id')} 
                           
                            name="party_id"
                            placeholder="Select Party"
                            component={Select}
                            disabled={!this.filterFormStore.getValue('election_id')}
                            required={true}
                          //  loadOptions={this.onLoadElectionsParty}
                              loadOptions={() => {
                                return api.party.getListAction({
                                    filters: {
                                        election_id: this.filterFormStore.getValue('election_id'),
                                        include_competitor_party: 1
                                    }
                                }).then((data: any) => {
                                    return data.data;
                                });
                            }} 
                            store={this.filterFormStore}
                            onChange={() => {
                                this.filterFormStore.setValue('candidate_id', null);
                            }}
                        />
                    </Col> : ''
                }

                {this.filterFormStore.getValue('election_id') ?
                    <Col md={2}>
                        <Field
                            key={'election_position_id_' +
                            this.filterFormStore.getValue('election_id') +
                            /* this.filterFormStore.getValue('user_party_id') + */
							this.user_party_id +
                            this.filterFormStore.getValue('party_id')
                            }
                            name="election_position_id"
                            placeholder="Select Position"
                            component={Select}
                            disabled={!this.filterFormStore.getValue('election_id')}
                            required={true}
                            loadOptions={() => {
                                return api.electionPosition.getListAction({
                                    filters: {
                                        election_id: this.filterFormStore.getValue('election_id'),
                                        party_id: IWindow.initialState.user.party_id,
                                        other_party_id: this.filterFormStore.getValue('party_id'),
                                        search_competitor: 1,
                                    }
                                });
                            }}
                            returnObject={true}
                            extraKey={'level'}
                            store={this.filterFormStore}
                            onChange={(item: any) => {
                                this.filterFormStore.setValue('level', null);
                                if (item) {
                                    this.filterFormStore.setValue('level', item.extraKey);
                                }
                                this.filterFormStore.setValue('state_id', null);
                                this.filterFormStore.setValue('senatorial_district_id', null);
                                this.filterFormStore.setValue('federal_constituency_id', null);
                                this.filterFormStore.setValue('local_government_area_id', null);
                                this.filterFormStore.setValue('state_constituency_id', null);
                                this.filterFormStore.setValue('ward_id', null);
                            }}
                        />
                    </Col> : ''
                }

                {this.filterFormStore.getValue('election_position_id') ?
                    <Col md={2}>
                        <Field
                            key={'candidate_filter_summary_' +
                            this.filterFormStore.getValue('party_id') + '_election_id' +
                            this.filterFormStore.getValue('election_id') + '_election_position_id' +
                            this.filterFormStore.getValue('election_position_id')
                            }
                            name="candidate_id"
                            placeholder="Select Candidate"
                            component={Select}
                            disabled={!this.filterFormStore.getValue('election_position_id')}
                            required={true}
                            loadOptions={() => {
                                return api.candidate.getListAction({
                                    filters: {
                                        election_id: this.filterFormStore.getValue('election_id'),
                                        party_id: this.filterFormStore.getValue('party_id'),
                                        election_position_id: this.filterFormStore.getValue('election_position_id'),
                                    }
                                });
                            }}
                            store={this.filterFormStore}
                        />
                    </Col> : ''
                }
                { this.filterFormStore.getValue('level')  !== 'polling_unit'?
                    <>
                    {this.stateDropDown()}
                    {this.senatorialDistrictDropDown()}
                    {this.federalConstituencyDropDown()}
                    {this.lgaDropDown()}
                    {this.stateConstituencyDropDown()}
                    {this.wardsDropDown()}
                    </> : ''
                }

                <Col md={3} lg={4} xl={3} className="grid-search">
                    {this.renderSearch()}
                </Col>
            </Row>
        );
    }

    getCandidateRow = (candidate: any,totalvotes: any) => {
        return <tr key={'candidate-row' + candidate.id}>
			
			<td>
                <div className=""> 
				{ 
					candidate.party_logo && candidate.party_logo.url ?
				<img src={candidate.party_logo.url} style={{width: 50, height: 50}}/> :
                                    <img src="https://fakeimg.pl/50x50/"/>                
									}
									</div>
                
            </td>
			
            <td>
                <div className="">
                    {candidate.party_name}
                </div>
            </td>
			<td>
				<div className="">{candidate.name}
                </div>
			</td>
            <td className="text-center">
                <div className="icon-candidates text-success my-1"></div>
                <div className="comp-position">
                    <div className="text-center">
                        <small>{candidate.position_name}</small>
                    </div>
                    <div className="text-center">
                        <small>{candidate.region_name}</small>
                    </div>
                </div>
            </td>
            <td><span className="spnvot" >
			<span className="spnvot spncolor" style={{width: Math.ceil( (candidate.votes / totalvotes) * 100) ? Math.ceil( (candidate.votes / totalvotes) * 100) : 0 + 'px'}}></span>
			</span></td>
			<td className="text-center "  >{ Math.ceil( (candidate.votes / totalvotes) * 100) ? Math.ceil( (candidate.votes / totalvotes) * 100) : 0 } %</td>
			<td className="text-center">
                <div className="comp-votes">
                    <span>{candidate.votes}</span>
                </div>
            </td>
			
			
        </tr>
    };

    onChangePosition = (position: any) => {
        this.candidate_by_position = this.electionSubscription.election_candidates_votes.filter((candidate: any) => {
            return candidate.position_id === position;
        }).map((candidate: any) => {
            return {
                label: candidate.name,
                value: candidate.votes
            };
        });
    };

    onLoadElections = () => {
        return api.election.getListAction({
            filters: {
                party_id: this.formStore.getValue('party_id'),
            }
        }).then((data: any) => {
            if (data && data.length) {
                this.formStore.setValue('election_id', data[0].id);
				 
                this.onChangeElection();
            }
            return data;
        });
    };
	
	goToElectionSubmitResult() {
        window.location.href = '/election-results';
    };

    renderFields() {
        return (

            <Row className="form-row">
			 
				<Col md={2}>
                 
                        <Field
                            key="dashboard-election"
                            name="election_id"
                            placeholder="Select Election..."
                            component={Select}
                            loadOptions={this.onLoadElections}
                            store={this.formStore}
                            required={true}
                            onChange={this.onChangeElection}
                        />
						
						{ this.is_admin == "superuser" ?
					 
						 <Field
                            key={'form_party_id_' + this.formStore.getValue('election_id')}
                            name="party_id"
                            placeholder="Select Party..."
                            component={Select}
                            // loadOptions={this.onLoadElections}
							loadOptions={() => {
                            return api.party.getListAction({
                                filters: {
                                    election_id: this.formStore.getValue('election_id') /* ,
                                    include_competitor_party: 0 */
                                }
                            }).then((data: any) => {
								if (data && data.length) {
									this.formStore.setValue('party_id', data[0].id);
									this.onChangeElection();
								}
							
                                return data.data;
                            });
                        }}
                            store={this.formStore}
                            required={true}
                            onChange={this.onChangeElection}
                        />
						: ''
						}
                    
				</Col>
				
				{this.formStore.getValue('election_id') ?
                    <Col md={2}>
                        <Field
                            key={'party_id_' + this.formStore.getValue('election_id')} 
                           
                            name="party_id"
                            placeholder="Select Party"
                            component={Select}
                            disabled={!this.formStore.getValue('election_id')}
                            required={true}
                          //  loadOptions={this.onLoadElectionsParty}
                              loadOptions={() => {
                                return api.party.getListAction({
                                    filters: {
                                        election_id: this.formStore.getValue('election_id'),
                                        include_competitor_party: 1
                                    }
                                }).then((data: any) => {
                                    return data.data;
                                });
                            }} 
                            store={this.formStore}
                            onChange={() => {
                                this.formStore.setValue('candidate_id', null);
                            }}
                        />
                    </Col> : ''
                }
				
				{this.formStore.getValue('election_id') ?
                    <Col md={2}>
                        <Field
                            key={'election_position_id_' +
                            this.formStore.getValue('election_id') +
                             this.formStore.getValue('party_id')
                            }
                            name="election_position_id"
                            placeholder="Select Position"
                            component={Select}
                            disabled={!this.formStore.getValue('election_id')}
                            required={true}
                            loadOptions={() => {
                                return api.electionPosition.getListAction({
                                    filters: {
                                        election_id: this.formStore.getValue('election_id'),
                                        party_id: IWindow.initialState.user.party_id,
                                        other_party_id: this.formStore.getValue('party_id'),
                                        search_competitor: 1,
                                    }
                                });
                            }}
                            returnObject={true}
                            extraKey={'level'}
                            store={this.formStore}
                            onChange={(item: any) => {
                                this.formStore.setValue('level', null);
                                if (item) {
                                    this.formStore.setValue('level', item.extraKey);
                                }
                                this.formStore.setValue('state_id', null);
                                this.formStore.setValue('senatorial_district_id', null);
                                this.formStore.setValue('federal_constituency_id', null);
                                this.formStore.setValue('local_government_area_id', null);
                                this.formStore.setValue('state_constituency_id', null);
                                this.formStore.setValue('ward_id', null);
                            }}
                        />
                    </Col> : ''
                }
				
				
				
				<div className="row">
				
				
						




					
				</div>
				
				
{ /*
                <div className="row">
				
								
				
				

                    <div className="col-xl-6 d-flex flex-column"
                         key={'subscription-polling-unit' + this.formStore.getValue('election_id')}>
                        <div className="card dashboard-card box-shadow border-0 rounded-0 flex-grow-1">
                            <div className="card-header d-flex align-items-center">
                                <span className="icon-nigerian-naira mr-2"></span>
                                <h6>Election Subscription</h6>
                            </div>
                            <div className="card-body py-0 d-flex flex-column">
                                <div className="row no-gutters flex-grow-1">
                                    <div
                                        className="col-sm-4 dash-sep-sm-right py-4 d-sm-flex flex-sm-column justify-content-sm-center">
                                        <div className="text-center">
                                            <div className="stat-label">Polling units<br/>subscribed</div>
                                            <div
                                                className="stat-value">{this.electionSubscription.election_polling_unit_subscriptions}</div>
                                        </div>
                                        <div className="text-center mt-4">
                                            <div className="stat-label">Polling units<br/>not subscribed</div>
                                            <div
                                                className="stat-value">{this.electionSubscription.election_unsubscribed_polling_unit}</div>
                                        </div>
                                    </div>
                                    <div className="col-sm-8 ">
                                        {
                                            this.formStore.getValue('election_id') ?
                                                <DoughnutChat
                                                    id="polling-unit-chart"
                                                    key={'polling-unit-subcripbtion-chart'}
                                                    title="Polling Units"
                                                    backgroundColor={[
                                                        'rgb(197,44,3)',
                                                        'rgb(41,138,61)',
                                                    ]}
                                                    backgroundHoverColor={[
                                                        'rgba(197,44,3, 0.8)',
                                                        'rgba(41,138,61, 0.78)',
                                                    ]}
                                                    legend={{
                                                        display: true
                                                    }}
                                                    data={[
                                                        {
                                                            label: 'Unsubscribed',
                                                            value: this.electionSubscription.election_unsubscribed_polling_unit,
                                                        },
                                                        {
                                                            label: 'Subscribed',
                                                            value: this.electionSubscription.election_polling_unit_subscriptions,
                                                        }
                                                    ]}
                                                /> : ''
                                        }

                                    </div>
                                </div>
                            </div>
                        </div>
						 
                    </div>
					
					
 
                    <div className="col-xl-6 mt-4 mt-xl-0 d-flex flex-column"
                         key={'subscription-candidates' + this.formStore.getValue('election_id')}>
                        <div className="card dashboard-card box-shadow border-0 rounded-0 flex-grow-1">
                            <div className="card-header d-flex align-items-center">
                                <span className="icon-candidates mr-2"></span>
                                <h6>Candidates </h6>
                                { 
                                    this.formStore.getValue('election_id') &&
                                    this.electionSubscription.election_positions &&
                                    this.electionSubscription.election_positions.length ?
                                        <div className="ml-auto col-md-5">
                                            <Field
                                                key="dashboard-position"
                                                name="position_id"
                                                placeholder="Select Postions..."
                                                component={Select}
                                                store={this.formStore}
                                                options={this.electionSubscription.election_positions}
                                                required={true}
                                                onChange={this.onChangePosition}
                                            />
                                        </div>
                                        : ''
                                }
                            </div>
                            <div className="card-body">
                                {
                                    this.formStore.getValue('position_id') &&
                                    this.candidate_by_position &&
                                    this.candidate_by_position.length ?
                                        <BarChart
                                            id="candidates-chart"
                                            key={'candidate-bar-chart'}
                                            title="Candidates Chart"
                                            data={this.candidate_by_position}/>
                                        : ''
                                }

                            </div>
                        </div>
                    </div>
					 
					
					

                </div>
				
 
                <div className="row py-2" key={'subscription-region' + this.formStore.getValue('election_id')}>
                    <div className="col-sm-6 col-xl-3 d-flex flex-column mt-3">
                        <div className="card stat-card box-shadow border-0 rounded-0 text-center">
                            <div className="stat-label">States</div>
                            <div className="stat-value">{this.electionSubscription.states}</div>
                        </div>
                    </div>

                    <div className="col-sm-6 col-xl-3 d-flex flex-column mt-3">
                        <div className="card stat-card box-shadow border-0 rounded-0 text-center">
                            <div className="stat-label">Senatorial Districts</div>
                            <div className="stat-value">{this.electionSubscription.senatorial_districts}</div>
                        </div>
                    </div>

                    <div className="col-sm-6 col-xl-3 d-flex flex-column mt-3">
                        <div className="card stat-card box-shadow border-0 rounded-0 text-center">
                            <div className="stat-label">Local Government Areas</div>
                            <div className="stat-value">{this.electionSubscription.local_government_areas}</div>
                        </div>
                    </div>

                    <div className="col-sm-6 col-xl-3 d-flex flex-column mt-3">
                        <div className="card stat-card box-shadow border-0 rounded-0 text-center">
                            <div className="stat-label">Wards</div>
                            <div className="stat-value">{this.electionSubscription.wards}</div>
                        </div>
                    </div>

                    <div className="col-sm-6 col-xl-3 d-flex flex-column mt-3">
                        <div className="card stat-card box-shadow border-0 rounded-0 text-center">
                            <div className="stat-label">Polling Units</div>
                            <div
                                className="stat-value">{this.electionSubscription.election_polling_unit_subscriptions}</div>
                        </div>
                    </div>

                    <div className="col-sm-6 col-xl-3 d-flex flex-column mt-3">
                        <div className="card stat-card box-shadow border-0 rounded-0 text-center">
                            <div className="stat-label">Federal Constituencies</div>
                            <div className="stat-value">{this.electionSubscription.federal_constituencies}</div>
                        </div>
                    </div>

                    <div className="col-sm-6 col-xl-3 d-flex flex-column mt-3">
                        <div className="card stat-card box-shadow border-0 rounded-0 text-center">
                            <div className="stat-label">State Constituencies</div>
                            <div className="stat-value">{this.electionSubscription.state_constituencies}</div>
                        </div>
                    </div>

                    <div className="col-sm-6 col-xl-3 d-flex flex-column mt-3">
                        <div className="card stat-card box-shadow border-0 rounded-0 text-center">
                            <div className="stat-label">Incidences</div>
                            <div className="stat-value text-danger">
                                {this.electionSubscription.incidence_count && this.formStore.getValue('election_id') ?
                                    <a href={"/party/" + this.formStore.getValue('election_id') + '/incidence'}
                                       className="text-danger" target="_blank">
                                        {this.electionSubscription.incidence_count} </a>
                                    : this.electionSubscription.incidence_count}
                            </div>
                        </div>
                    </div>

                </div>
*/ }
                <div className="mt-3">

                    <div className="d-flex flex-column">
                        <div className="card dashboard-card box-shadow border-0 rounded-0 flex-grow-1">
                            
                            <div className="card-body py-0 d-flex flex-column">
                                


							<div className="card-header d-flex align-items-center">
                                <span className="icon-bar-chart mr-2"></span>
                                <h6>ELECTION RESULTS</h6>
                            </div>
							
							
								<div className="row pt-2">
									
									<div className="col-sm-6 col-xl-4 d-flex flex-column mt-2" key={'inecVoters'}>
										<div className="card stat-cardcnt box-shadow border-0 rounded-0 text-center">
											<div className="stat-labelcnt">INEC REGISTERED<br/> VOTERS</div>
											<div className="stat-valuecnt">{this.electionSubscription.registeredVoters}</div>
										</div>
									</div>
									
									
									<div className="col-sm-6 col-xl-2 d-flex flex-column mt-2" key={'registeredVoters'}>
										<div className="card stat-cardcnt box-shadow border-0 rounded-0 text-center">
											<div className="stat-labelcnt">REGISTERED VOTERS AT POLLING UNIT</div>
											<div className="stat-valuecnt">{this.electionSubscription.registeredVoters}</div>
										</div>
									</div>
									
									  
									 <div className="col-sm-6 col-xl-2 d-flex flex-column mt-2" key={'accreditedVoters'}>
										<div className="card stat-cardcnt box-shadow border-0 rounded-0 text-center">
											<div className="stat-labelcnt">POLLING UNIT ACCREDICTED VOTERS</div>
											<div className="stat-valuecnt">{this.electionSubscription.accreditedVoters}</div>
										</div>
									</div> 
									
									
									<div className="col-sm-6 col-xl-2 d-flex flex-column mt-2" key={'rejectedVoters'}>
										<div className="card stat-cardcnt box-shadow border-0 rounded-0 text-center">
											<div className="stat-labelcnt">POLLING UNIT REJECTED VOTES</div>
											<div className="stat-valuecnt">{this.electionSubscription.rejectedVoters}</div>
										</div>
									</div> 
										
									<div className="col-sm-6 col-xl-2 d-flex flex-column mt-2" key={'disputedVoters'}>
										<div className="card stat-cardcnt box-shadow border-0 rounded-0 text-center">
											<div className="stat-labelcnt">POLLING UNIT DISPUTED VOTES</div>
											<div className="stat-valuecnt">{this.electionSubscription.disputedVoters}</div>
										</div>
									</div> 
									
										
								
								</div>
								


								<div className="row pt-2">&nbsp;</div>
								<div className="row pt-2">&nbsp;</div>

                                <div className="row pt-2">
                             
                               
							   
                                    <div className="col-xl-12 dash-sep-xl-right">
                                        
                                        <div className="competitor-list table-responsive"
                                             key={"my-party" + this.formStore.getValue('election_id')}>
                                            <table className="table table-hover border-top bgcolornw">
												<thead>
													<th>Logo</th>
													<th>Party</th>
													<th>Candidate Name</th>
													<th className="text-center">Postions</th>
													<th></th>
													<th className="text-center">%</th>
													<th className="text-center">Votes</th>
												</thead>
                                                <tbody>
												{
													
												
                                                    this.formStore.getValue('election_id') && this.party_candidates &&
                                                    this.party_candidates.length ?
                                                        this.party_candidates.map((candidate: any) => {
                                                            return (
                                                                this.getCandidateRow(candidate,this.electionSubscription.total_votes)
                                                            );
                                                        }, this)
                                                        : <tr>
                                                            <td col-span={6}>
                                                                <div className="comp-candidate">No Candidates</div>
                                                            </td>
                                                        </tr>
                                                }
												
														<tr>
															<td>&nbsp; </td>
															<td>&nbsp; </td>
															<td>&nbsp; </td>
															
															
															<td colSpan={3} className="text-right" >Total Valid Votes:</td>
															<td className="text-center fotvalue">{this.electionSubscription.total_votes}</td>
														</tr>	
														
														<tr>
															<td>&nbsp; </td>
															<td>&nbsp; </td>
															<td>&nbsp; </td>
															
															
															<td  colSpan={3}  className="text-right">Disputed Votes:</td>
															<td className="text-center fotvalue coldispute">{this.electionSubscription.disputedVoters}</td>
														</tr>

														<tr>
															<td>&nbsp; </td>
															<td>&nbsp; </td>
															<td>&nbsp; </td>
																														
															
															<td  colSpan={3} className="text-right">Rejected Votes:</td>
															<td className="text-center fotvalue colrej">{this.electionSubscription.rejectedVoters}</td>
														</tr>	

														<tr className="bggrand">
															<td>&nbsp; </td>
															<td>&nbsp; </td>
															<td>&nbsp; </td>
																																													
															<td  colSpan={3} className="text-right">Grand Total:</td>
															<td className="text-center fotvalue">{(this.electionSubscription.grandTotal)}</td>
														</tr>															

                                                </tbody>
                                            </table>
                                        </div>

                                    </div>
									
									
                                 
                 
                              


                                    




                                    


                               
                </div>


                <div className="row pt-2">&nbsp;</div>







                            </div>
                        </div>
                    </div>

                </div>

                






               









            </Row>
        );
    }
}

export class ResultSummaryNewPage extends React.Component {
    modelName = 'Dashboard';

    render() {
        return (
            <>
                <ResultSummaryNewForm
                />
            </>
        );
    }
}



// WEBPACK FOOTER //
// ./resources/js/components/pages/ResultSummaryNewPageBackup - Copy.tsx